var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ExistingItems',{attrs:{"items":_vm.items,"title":"Υφιστάμενες Μάρκες"},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('router-link',{attrs:{"to":{
        name: 'products.brands.edit',
        params: { uuid: props.item.uuid },
      }}},[_c('Photo',{attrs:{"photos":props.item.photos}}),_c('span',[_vm._v(_vm._s(props.item.title))])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }